// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretDownFilledSvg from "@fishx/icons-svg/es/asn/CaretDownFilled";
import FishxIcon from '../components/FishxIcon';

var CaretDownFilled = function CaretDownFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownFilledSvg
  }));
};

CaretDownFilled.displayName = 'CaretDownFilled';
export default React.forwardRef(CaretDownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretDownFilled.js
// module id = 2161
// module chunks = 0